import React, { useState, useEffect, useRef } from 'react';
import api from '../utils/axios-util';
import 'font-awesome/css/font-awesome.min.css';
import person from "../assets/images/person.svg";
import '../assets/css/calllog.css';  // Import your CSS file for styling

function CallLog() {
  const [contacts, setContacts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [callDates, setCallDates] = useState([]);
  

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const response = await api.get('/crm/calllog');
        const data = response.data.data;
        const formattedDates = data.map((contact) => {
          const element = contact.calldate;
          return formatDate(element);
        });

        setContacts(data);
        setCallDates(formattedDates);
      } catch (error) {
        console.error('Error fetching contacts:', error);
      }
    };

    fetchContacts();
  }, []);

  const filteredContacts = contacts.filter((contact) =>
    contact.phone_number.includes(searchTerm)
  );
 
  return (
    <div className="App">
      <div className="contact-list">
        <div className="contact-list-title"></div>
        <div className="search-container">
         
          <input
            className="calllogsearch"
            type="text"
            placeholder="Search Number"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>


        {filteredContacts.length === 0 ? (
          <p className="no-data-message">No Data </p>
        ) : (
          <ul className="contact-items">
            {filteredContacts.map((contact, index) => (
              <li key={contact.id} className="contact-item">
                <img
                  src={person}
                  alt={contact.agent}
                  className="contact-image"
                />
                <div className="contact-details">
                  <h3>{contact.name}</h3>
                  <div className='pnumber'>{contact.phone_number}</div>
                  <div className="call-type" >{contact.status}</div>
                  <p className="call-date"> {callDates[index]} </p>
                </div>


              </li>
            ))}
          </ul>
        )}



      </div>

   
     

    </div>
  );
}

function formatDate(datestring) {
  const date = new Date(datestring); // Convert the date string to a Date object
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // January is 0
  const day = date.getDate().toString().padStart(2, '0');
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export default CallLog;
